/**
 * ./components/Curtain.js
 *
 * This component provides a **curtain transition effect** that can 
 * appear and disappear with smooth **CSS animations**.
 *
 */
import React from 'react';
import './Curtain.css';

const Curtain = ({ appear, disappear, duration }) => {
  const style = {
    animation: `${appear ? 'curtainAppear' : ''} ${disappear ? 'curtainDisappear' : ''} ${duration}ms ease-in-out forwards`,
    backgroundColor: '#889BD3', // Added inline style
  };

  return <div className="curtain" style={style}></div>;
};

export default Curtain;
